import { render, staticRenderFns } from "./ObjetivoCrianca.vue?vue&type=template&id=66ffdc1a&scoped=true"
import script from "./ObjetivoCrianca.vue?vue&type=script&lang=js"
export * from "./ObjetivoCrianca.vue?vue&type=script&lang=js"
import style0 from "./ObjetivoCrianca.vue?vue&type=style&index=0&id=66ffdc1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ffdc1a",
  null
  
)

export default component.exports